// extracted by mini-css-extract-plugin
export default {"dataRow":"ShiftLoaderTable_dataRow__slZr1","boldCell":"ShiftLoaderTable_boldCell__ZsBwx"};